import Ionicons from '@expo/vector-icons/Ionicons';
import { Text, View } from 'react-native';
import type { SearchTab } from '../hooks/use-search-state';

interface SearchEmptyStateProps {
  variant: 'initial-prompt' | 'no-results';
  activeTab: SearchTab;
  query: string;
}

const TAB_LABELS: Record<SearchTab, string> = {
  places: 'restaurants',
  people: 'people',
  'menu-items': 'menu items',
};

export function SearchEmptyState({ variant, activeTab, query }: SearchEmptyStateProps) {
  if (variant === 'initial-prompt') {
    return (
      <View className="flex-1 items-center justify-center px-8">
        <Ionicons name="search-outline" size={64} className="text-muted-foreground" />
        <Text className="text-xl font-semibold mt-6 text-center text-foreground">
          Discover something new
        </Text>
        <Text className="text-base mt-3 text-center leading-relaxed text-muted-foreground">
          Search for restaurants, people, or menu items
        </Text>
      </View>
    );
  }

  return (
    <View className="py-8 items-center">
      <Ionicons name="search-outline" size={48} className="text-muted-foreground" />
      <Text className="text-lg font-semibold mt-4 text-foreground">
        No matches found
      </Text>
      <Text className="text-sm mt-2 text-center px-4 text-muted-foreground">
        {`No ${TAB_LABELS[activeTab]} found for "${query}"`}
      </Text>
    </View>
  );
}
